/**
 * Con qué permisos se siembra una invitación al portal de UN cliente: los módulos de su portal
 * (`GET client/:id/portal/config/` → `modules`), más las claves que el portal no maneja
 * (`data_explorer`, `insights`) apagadas.
 *
 * Por qué importa sembrar desde el portal y no fijar los permisos en el código: al aceptar, el
 * backend guarda como excepción por usuario TODO permiso que difiera de lo que el portal ya le da
 * (`PortalCapabilityService.apply_invitation_features`), y una excepción queda fija aunque después
 * cambie el portal. «Invitar al cliente a conectar» mandaba Informes y MCP en `false` escritos a
 * mano: la persona entraba con los dos apagados para siempre (punto 23 del recorrido de la 2.1).
 *
 * `overrides` es lo que el punto de invitación agrega a propósito — «Invitar al cliente a
 * conectar» existe para darle `connections`, así que lo fuerza.
 */
export function portalInviteFeatures(modules, overrides = {}) {
    const portal = modules || {};
    return {
        dashboard: !!portal.dashboard,
        data_explorer: false,
        connect: !!portal.connect,
        reports: !!portal.reports,
        insights: false,
        connections: !!portal.connections,
        ...overrides,
    };
}
